import { useEffect, useState } from "react";
import AddUserContainer from "../../components/AddUser/AddUserContainer";
import { styled } from "styled-components";
import { DashboardGoBackButton } from "../../components/Untils/DashboardGoBackButton";
import { PaymentLinkHeaderText } from "../../components/DashBoardComponents/ContentWrapper/ContentWrapper.styles";
import Button from "../../components/Button/Button";
import { colors } from "../../theme/color";
import { PaymentLinkTitleText } from "../Dashboard/Dashboard.styles";
import { addUsers } from "../../graphql/mutations/userManagement";
import { emailRegex } from "../../utils/EmailValidation";
import { useMutation, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { getAllRoles } from "../../graphql/queries/userManagement";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
import { setLoading } from "../../store/loadingSpinner";
import { toast } from "react-toastify";

export interface AddUserFormValues {
  fullName: string;
  email: string;
  phone: string;
  selectedUserType: string;
}
const AddUser = () => {
  const dispatch = useDispatch();
  const organizationId = useSelector(
    (state: RootState) => state.user?.user.organizationId
  );
  const navigate = useNavigate();
  const [addUsersMutation, { loading, error, data }] = useMutation(addUsers);
  const [validationErrors, setValidationErrors] = useState<string | null>(null);
  const [selectedUserTypes, setSelectedUserTypes] = useState<string[]>([]);
  const [users, setUsers] = useState<AddUserFormValues[]>([
    {
      fullName: "",
      email: "",
      phone: "",
      selectedUserType: "",
    },
  ]);
  const [formData] = useState<AddUserFormValues>({
    fullName: "",
    email: "",
    phone: "",
    selectedUserType: "",
  });

  const { data: roleData } = useQuery(getAllRoles);
  const roles = roleData?.getAllRoles.data || [];
  useEffect(() => {
    if (roles.length > 0) {
      const userTypes = roles.map((role: any) => role.name);
      setSelectedUserTypes(userTypes);
    }
  }, [roles]);

  const handleUserTypeChange = (userType: string, index: number) => {
    const newArr = [...users];
    const requiredForm = newArr[index];
    requiredForm.selectedUserType = userType;
    newArr[index] = requiredForm;
    setUsers(newArr);
  };

  const validateUserField = (
    fieldName: keyof AddUserFormValues,
    value: string
  ): string | null => {
    switch (fieldName) {
      case "fullName":
        return value ? null : "Full name is required";
      case "email":
        return emailRegex.test(value) ? null : "Invalid email format";
      case "phone":
        return value ? null : "Phone number is required";
      default:
        return null;
    }
  };

  const handleChange = (
    fieldName: keyof AddUserFormValues,
    value: string,
    index: number
  ) => {
    const newUsers = [...users];
    newUsers[index][fieldName] = value;
    setUsers(newUsers);

    const validationError = validateUserField(fieldName, value);
    setValidationErrors(validationError);
  };

  const startAddingUser = () => {
    setUsers([...users, { ...formData }]);
  };
  const validUsers = () => {
    return users.filter((user) =>
      Object.values(user).every((value) => value !== "")
    );
  };
  const isFormValid = () => {
    const lastUser = users[users.length - 1];
    return (
      lastUser.email !== "" && lastUser.fullName !== "" && lastUser.phone !== ""
    );
  };

  const handleAddUser = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    const lastUser = users[users.length - 1];
    const validationError = Object.keys(lastUser).reduce<string | null>(
      (error, fieldName) => {
        if (!lastUser[fieldName as keyof AddUserFormValues]) {
          return error || `${fieldName} is required`;
        }
        return error;
      },
      null
    );
    if (validationError) {
      setValidationErrors(validationError);
      return;
    }
    dispatch(setLoading(true));
    try {
      const result = await addUsersMutation({
        variables: {
          input: users.map((user) => ({
            fullName: user.fullName,
            // firstName: user.fullName.split(" ")[0],
            // lastName: user.fullName.split(" ")[1],
            email: user.email,
            phone: user.phone,
            organization_role_id: roles.find(
              (userRole: any) => userRole.name === user.selectedUserType
            )?.id,
          })),
        },
      });
      navigate("/dashboard/user-profile");
      if (users.length === 1) {
        toast.success("User added successfully");
      } else {
        toast.success("Multiple users added successfully");
      }
      setUsers([]);
      setValidationErrors(null);
    } catch (error) {
      console.error("Error adding users:", error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleDeleteUser = (index: number) => {
    const newArr = [...users];
    const filteredArr = newArr.filter((user) => newArr.indexOf(user) !== index);
    setUsers(filteredArr);
  };
  return (
    <AddUserWrapper>
      <DashboardGoBackButton />
      <PaymentLinkHeaderText>Add New User</PaymentLinkHeaderText>
      <ContainerStyle>
        <SubText>
          <PaymentLinkTitleText>Add New User</PaymentLinkTitleText>
        </SubText>
        <FormContainer onSubmit={handleAddUser}>
          {users.map((user, index) => (
            <AddUserContainer
              formData={user}
              selectedUserType={user.selectedUserType}
              handleUserTypeChange={handleUserTypeChange}
              handleChange={handleChange}
              startAddingUser={startAddingUser}
              showDelete={index < users.length - 1}
              index={index}
              deleteUser={handleDeleteUser}
              validationErrors={validationErrors}
            />
          ))}
          <ButtonContainer>
            <Button
              id={""}
              type="submit"
              disabled={!isFormValid()}
              onClick={() => {}}
              padding={"10px 60px"}
              title={"Add User"}
              border="5px"
              green
            />
          </ButtonContainer>
        </FormContainer>
      </ContainerStyle>
    </AddUserWrapper>
  );
};

export default AddUser;

export const AddUserWrapper = styled.div`
  padding: 1rem;
`;
export const ContainerStyle = styled.div`
  background-color: ${colors.White};
  width: 78vw;
  border-radius: 10px;
  position: relative;
  @media screen and (max-width: 767px) {
    height: auto;
    width: 100%;
  }
`;
export const Hrule = styled.div`
  height: 1px;
  background: #e8eaed;
  width: 100%;
  padding: 0;
  margin: 0;
`;
export const SubText = styled.div`
  padding: 1rem;
`;
export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
`;
export const ButtonContainer = styled.div`
  margin: 8rem 2rem 2rem auto;
  @media screen and (max-width: 767px) {
    margin: 5rem 2rem 2rem auto;
  }
`;
export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  backdrop-filter: blur(3px);
`;
export const LoadingSpinner = styled.div<{
  css?: string;
  small?: boolean;
  $auto?: boolean;
}>`
  border: 7px solid rgba(0, 0, 0, 0.1);
  border-left: 7px solid ${colors.general.vividMalachite};
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  ${({ small }) =>
    small
      ? `
    position: relative;
    width: 20px;
    height: 20px;
  `
      : ""}
  ${({ $auto }) =>
    $auto
      ? `
      top:auto;
  left:auto;
  transform:none;
  `
      : ""}
  ${({ css }) => css || ""}
`;

export const LoadingSpinner1 = styled.div<{
  css?: string;
  small?: boolean;
  $auto?: boolean;
}>`
  border: 7px solid rgba(0, 0, 0, 0.1);
  border-left: 7px solid ${colors.general.vividMalachite};
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  position: absolute;
  top: 50%;
  left: 44%;
  transform: translate(-50%, -50%);

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  ${({ small }) =>
    small
      ? `
    position: relative;
    width: 20px;
    height: 20px;
    left: 40%;
  `
      : ""}
  ${({ $auto }) =>
    $auto
      ? `
      top:auto;
  left:auto;
  transform:none;
  `
      : ""}
  ${({ css }) => css || ""}
`;
